export default [
    {
        "id": 1,
        "nameKey": 'home.industry.mainTransport',
        icon: require('@/assets/img/IndustryModel/icon/icon-主运输.png'),
        list: [
            {
                image: require('@/assets/img/IndustryModel/主运输/动态皮带区域识别.png'),
                titleKey: 'home.industry.models.mainTransport.dynamicBelt',
            },
            {
                image: require('@/assets/img/IndustryModel/主运输/煤仓上口堆煤识别.png'),
                titleKey: 'home.industry.models.mainTransport.coalBunker',
            },
            {
                image: require('@/assets/img/IndustryModel/主运输/皮带乘人越位监测.png'),
                titleKey: 'home.industry.models.mainTransport.beltRider',
            },
            {
                image: require('@/assets/img/IndustryModel/主运输/皮带大块煤识别.png'),
                titleKey: 'home.industry.models.mainTransport.largeCoal',
            },
            {
                image: require('@/assets/img/IndustryModel/主运输/皮带异物识别.png'),
                titleKey: 'home.industry.models.mainTransport.foreignObject',
            },
            {
                image: require('@/assets/img/IndustryModel/主运输/皮带煤量监测.png'),
                titleKey: 'home.industry.models.mainTransport.coalVolume',
            },
            {
                image: require('@/assets/img/IndustryModel/主运输/皮带跑偏识别.png'),
                titleKey: 'home.industry.models.mainTransport.beltDeviation',
            },
            {
                image: require('@/assets/img/IndustryModel/主运输/皮带锚杆识别.png'),
                titleKey: 'home.industry.models.mainTransport.boltDetection',
            },
        ]
    },
    {
        "id": 4,
        "nameKey": 'home.industry.auxTransport',
        icon: require('@/assets/img/IndustryModel/icon/icon-辅助运输.png'),
        list: [
            {
                image: require('@/assets/img/IndustryModel/辅助运输/乘坐猴车携带超长物料.png'),
                titleKey: 'home.industry.models.auxTransport.monkeyCar',
            },
            {
                image: require('@/assets/img/IndustryModel/辅助运输/人车静态落闸识别.png'),
                titleKey: 'home.industry.models.auxTransport.manCarGate',
            },
            {
                image: require('@/assets/img/IndustryModel/辅助运输/倚靠人车识别.png'),
                titleKey: 'home.industry.models.auxTransport.leanManCar',
            },
            {
                image: require('@/assets/img/IndustryModel/辅助运输/料车超挂告警.png'),
                titleKey: 'home.industry.models.auxTransport.overLoad',
            },
            {
                image: require('@/assets/img/IndustryModel/辅助运输/绞车硐室检修规范操作识别.png'),
                titleKey: 'home.industry.models.auxTransport.winchRoom',
            },
            {
                image: require('@/assets/img/IndustryModel/辅助运输/绞车道人数统计.png'),
                titleKey: 'home.industry.models.auxTransport.tunnelCount',
            },
            {
                image: require('@/assets/img/IndustryModel/辅助运输/胶轮车不能把头伸出车外.png'),
                titleKey: 'home.industry.models.auxTransport.rubberCarHead',
            },
            {
                image: require('@/assets/img/IndustryModel/辅助运输/行车不行人.png'),
                titleKey: 'home.industry.models.auxTransport.noRider',
            },
            {
                image: require('@/assets/img/IndustryModel/辅助运输/趴蹬矿车识别.png'),
                titleKey: 'home.industry.models.auxTransport.mineCarRide',
            },
            {
                image: require('@/assets/img/IndustryModel/辅助运输/防跑车装置状态识别.png'),
                titleKey: 'home.industry.models.auxTransport.antiRunaway',
            },
        ]
    },
    {
        "id": 3,
        "nameKey": 'home.industry.mining',
        icon: require('@/assets/img/IndustryModel/icon/icon-采煤.png'),
        list: [
            {
                image: require('@/assets/img/IndustryModel/采煤/刮板机辅助找直检测.png'),
                titleKey: 'home.industry.models.mining.scraperAlign',
            },
            {
                image: require('@/assets/img/IndustryModel/采煤/刮板运输机断链监测.png'),
                titleKey: 'home.industry.models.mining.chainBreak',
            },
            {
                image: require('@/assets/img/IndustryModel/采煤/动态危险区域闯入识别.png'),
                titleKey: 'home.industry.models.mining.dangerZone',
            },
            {
                image: require('@/assets/img/IndustryModel/采煤/滚筒与护帮板状态监测.png'),
                titleKey: 'home.industry.models.mining.rollerGuard',
            },
        ]
    },
    {
        "id": 2,
        "nameKey": 'home.industry.tunneling',
        icon: require('@/assets/img/IndustryModel/icon/icon-掘进.png'),
        list: [
            {
                image: require('@/assets/img/IndustryModel/掘进/掘进机上作业系安全绳识别.png'),
                titleKey: 'home.industry.models.tunneling.safetyRope',
            },
            {
                image: require('@/assets/img/IndustryModel/掘进/机载临时支护使用检测.png'),
                titleKey: 'home.industry.models.tunneling.temporarySupport',
            },
            {
                image: require('@/assets/img/IndustryModel/掘进/甲烷瓦斯探头检测.png'),
                titleKey: 'home.industry.models.tunneling.gasProbe',
            },
            {
                image: require('@/assets/img/IndustryModel/掘进/防护网开关识别.png'),
                titleKey: 'home.industry.models.tunneling.safetyNet',
            },
        ]
    },
    {
        "id": 5,
        "nameKey": 'home.industry.ventilation',
        icon: require('@/assets/img/IndustryModel/icon/icon-通风.png'),
        list: [
            {
                image: require('@/assets/img/IndustryModel/通风/风道人员记录.png'),
                titleKey: 'home.industry.models.ventilation.tunnelPerson',
            },
            {
                image: require('@/assets/img/IndustryModel/通风/风道巷道形变监测.png'),
                titleKey: 'home.industry.models.ventilation.tunnelDeform',
            },
            {
                image: require('@/assets/img/IndustryModel/通风/风门开关状态识别.png'),
                titleKey: 'home.industry.models.ventilation.damperSwitch',
            },
        ]
    },
    {
        "id": 6,
        "nameKey": 'home.industry.others',
        icon: require('@/assets/img/IndustryModel/icon/icon-其他.png'),
        list: [
            {
                image: require('@/assets/img/IndustryModel/其他/人员在岗识别.png'),
                titleKey: 'home.industry.models.others.onDuty',
            },
            {
                image: require('@/assets/img/IndustryModel/其他/人员睡岗识别.png'),
                titleKey: 'home.industry.models.others.sleepDuty',
            },
            {
                image: require('@/assets/img/IndustryModel/其他/人员聚集监测.png'),
                titleKey: 'home.industry.models.others.crowd',
            },
            {
                image: require('@/assets/img/IndustryModel/其他/人脸识别.png'),
                titleKey: 'home.industry.models.others.faceRecog',
            },
            {
                image: require('@/assets/img/IndustryModel/其他/关键硐室人员经过记录.png'),
                titleKey: 'home.industry.models.others.keyRoom',
            },
            {
                image: require('@/assets/img/IndustryModel/其他/危险区域人员闯入.png'),
                titleKey: 'home.industry.models.others.dangerZone',
            },
            {
                image: require('@/assets/img/IndustryModel/其他/摄像头遮挡检测.png'),
                titleKey: 'home.industry.models.others.cameraCover',
            },
            {
                image: require('@/assets/img/IndustryModel/其他/未佩戴安全帽识别.png'),
                titleKey: 'home.industry.models.others.noHelmet',
            },
            {
                image: require('@/assets/img/IndustryModel/其他/水位预警识别.png'),
                titleKey: 'home.industry.models.others.waterLevel',
            },
            {
                image: require('@/assets/img/IndustryModel/其他/设备高温预警.png'),
                titleKey: 'home.industry.models.others.highTemp',
            },
        ]
    },
]